module.exports = __webpack_public_path__ + "img/img404.4c18ec24.jpg";